module.exports = __webpack_public_path__ + "fonts/trellicons.f91041f7538332ce9a4a.eot";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/trellicons.eot
// module id = 9sX3
// module chunks = 24